import { Symbol } from '../Core/Symbol';
import { ITranslationProvider } from './ITranslationProvider';
import { TranslationModule } from './TranslationModule';

export type ModuleKeyValueTable = { [module: string]: { [key: string]: string } };

/**
 * A service that provides translations obtained from the native layer.
 */
export class TranslationProvider implements ITranslationProvider {
  /**
   * Gets the active language.
   *
   * @returns {string} the active language.
   */
  readonly getActiveLanguage = () => {
    return this.activeLanguage;
  }

  /**
   * Gets the active language script.
   *
   * @returns {string} the active language scrip.
   */
  readonly getActiveLanguageScript = () => {
    return this.activeLanguageScript;
  }

  /**
   * Gets the active language region.
   *
   * @returns {string} the current language region.
   */
  readonly getActiveLanguageRegion = () => {
    return this.activeLanguageRegion;
  }

  /**
   * Get a translation for a key.
   *
   * @param module - the name of the module within which to find the key
   * @param key - the key to translate.
   * @returns {string} - the translated value.
   */
  readonly get = (module: string, key: string) => {
    return this.translations[module][key];
  }

  readonly set = (data: ModuleKeyValueTable, activeLanguage: string, activeLanguageScript: string, activeLanguageRegion: string) => {
    this.translations = data;
    this.activeLanguage = activeLanguage;
    this.activeLanguageScript = activeLanguageScript;
    this.activeLanguageRegion = activeLanguageRegion;
  }

  readonly symbol: Symbol = TranslationModule.serviceSymbol;

  private activeLanguage!: string;
  private activeLanguageScript!: string;
  private activeLanguageRegion!: string;
  private translations!: ModuleKeyValueTable;
}
